export enum Variant {
  main = 'main',
  idigest = 'idigest',
  fishmeet = 'fishmeet'
  // If there are new variants in the future
}

/**
 * Determines the runtime variant based on the hostname or URL search parameters.
 *
 * usage: getRuntimeVariant() === Variant.fishmeet
 */
export const getRuntimeVariant = (): Variant => {
  const hostname = window.location.hostname;
  const search = window.location.search;

  fishmeet: {
    // Check the domain name prefix
    if (
      hostname.startsWith('fishmeet.') ||
      // for localhost dev: `127.0.0.1	local.fishmeet.online`
      hostname.startsWith('local.fishmeet.') ||
      hostname.startsWith('m.') ||
      hostname.startsWith('meeting.')
    ) {
      return Variant.fishmeet;
    }

    // Check whether the url parameter contains meeting=1
    if (search.includes('meeting=1')) {
      return Variant.fishmeet;
    }

    break fishmeet;
  }

  return Variant.idigest;
};
